import { DeliveryPointSchedule } from '../types/delivery-point.type';
import { STORABLE_DAYS } from '../types/delivery-point-day.type';

// Un jour que la collection ne devrait pas contenir passe en fin de liste plutôt qu'en tête :
// `indexOf` renvoie -1, qui trierait avant lundi.
const dayRank = (day: string): number => {
  const rank = STORABLE_DAYS.indexOf(day as typeof STORABLE_DAYS[number]);

  return rank === -1 ? Number.MAX_SAFE_INTEGER : rank;
};

// Les heures sont normalisées en `HH:MM` par l'API, heure sur deux chiffres : la comparaison de
// chaînes suffit à obtenir l'ordre chronologique. Un dépôt absent compte comme vide et précède.
const sortKeys = (schedule: DeliveryPointSchedule): [number, string, string, string, string] => [
  dayRank(schedule.day),
  schedule.deposit?.from ?? '',
  schedule.deposit?.to ?? '',
  schedule.pickup.from,
  schedule.pickup.to,
];

export const sortSchedules = (schedules: DeliveryPointSchedule[]): DeliveryPointSchedule[] =>
  [...schedules].sort((first, second) => {
    const firstKeys = sortKeys(first);
    const secondKeys = sortKeys(second);

    for (let index = 0; index < firstKeys.length; index += 1) {
      if (firstKeys[index] < secondKeys[index]) return -1;
      if (firstKeys[index] > secondKeys[index]) return 1;
    }

    return 0;
  });
